export enum ReportsSortBy {
  BPExpiration = 'BPExpiration',
  ActualDate = 'actualDate',
  AssignedAgent = 'assignedAgent',
  ClosedCount = 'closedCount',
  DaysOverdue = 'daysOverdue',
  DurationDays = 'durationDays',
  FoundationPercent = 'foundationPercent',
  ForecastDate = 'forecastedDate',
  NetChange = 'netChange',
  NewCount = 'newCount',
  PausedDays = 'pausedDays',
  Period = 'period',
  ProjectBundleID = 'projectBundleID',
  ProjectStatus = 'projectStatus',
  ProjectType = 'projectType',
  ProvidenceDays = 'providenceDays',
  ProgressStatus = 'progressStatus',
  SiteNumber = 'siteNumber',
  StructuralResult = 'structuralResult',
  TaskName = 'taskName',
  TotalProjectDays = 'totalProjectDays',
  TowerPercent = 'towerPercent',
}
